import { service } from '../axios';
export function uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return service({
        url: '/upload/image',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
export function uploadSimple(file, bizType, bizKey) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bizType', bizType);
    if (bizKey) {
        formData.append('bizKey', bizKey);
    }
    return service({ url: '/files/uploadSimple',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
export function uploadFile(file, bizType, sessionId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bizType', bizType);
    if (sessionId) {
        formData.append('sessionId', sessionId);
    }
    return service({ url: '/files/upload',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
export function getSessionFiles(params) {
    return service({
        url: '/files/getSessionFiles',
        method: 'get',
        params
    });
}
export function openUploadSession(sessionId) {
    return service({
        url: '/files/session/open',
        method: 'post',
        params: { sessionId }
    });
}
export function checkUploadSession(sessionId, token) {
    return service({
        url: '/files/session/check',
        method: 'post',
        params: { sessionId, token }
    });
}
export function removeSessionFile(sessionId, fileId) {
    return service({
        url: '/files/session/removeSessionFile',
        method: 'post',
        data: { sessionId, fileId }
    });
}
export function closeUploadSession(sessionId) {
    return service({
        url: '/files/session/close',
        method: 'post',
        params: { sessionId }
    });
}
export function uploadExcel(file, bizType, reportYear) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bizType', bizType);
    formData.append('reportYear', reportYear);
    return service({
        url: '/files/uploadExcel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
